import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sectionTitle'
})
export class SectionTitlePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
